<template>
  <div class="loginForm modal fade" id="ruleModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-3"></column>
      <column class="col-md-6">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <i slot="icon-title" :class="getClass(rule.Type)"></i>
          <div slot="content">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">Rule Name</label>
                <div class="col-sm-9">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" placeholder="Rule Name" v-model="rule.Name" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Rule Type</label>
                <div class="col-sm-9">
                  <div class="col-sm-1">
                    <i :class="getClass(rule.Type)"></i>
                  </div>
                  <div class="col-sm-11">
                    <select class="form-control" v-model="rule.Type" style="padding-left: 0px; text-align: center;">
                      <option v-for="ruleType in $root.alertTypes" :value="ruleType.value" v-if="canShowRule(ruleType)">{{ruleType.title}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group" v-show="rule.Type != 'ExportPrinters'">
                <label class="col-sm-3 control-label">Description</label>
                <div class="col-sm-9">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" placeholder="Rule Description" v-model="rule.Description" />
                  </div>
                </div>
              </div>
              <div class="form-group" v-show="rule.Type != 'ExportPrinters'">
                <label class="col-sm-3 control-label">Condition</label>
                <div class="col-sm-9">
                  <div class="col-sm-3">
                    <select class="form-control" v-model="rule.Condition.key" style="padding-left: 0px; text-align: center;">
                      <option v-for="(item,index) in conditionKeys" :value="item">{{ item.title }}</option>
                    </select>
                  </div>
                  <div class="col-sm-3">
                    <select class="form-control" v-model="rule.Condition.operation" style="padding-left: 0px; text-align: center;">
                      <option v-for="(item,index) in conditionOperations" :value="item">{{ item }}</option>
                    </select>
                  </div>
                  <div class="col-sm-6" v-show="rule.Condition.operation!=='Changed'">
                    <input type="text" class="form-control" placeholder="Value" v-model="rule.Condition.value" />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Action</label>
                <div class="col-sm-9">
                  <div class="col-sm-4">
                    <select v-show="rule.Type != 'ExportPrinters'" class="form-control" style="padding-left: 0px; text-align: center;" v-model="rule.Action.key">
                      <option v-for="(item,index) in actions" :value="item">{{ item }}</option>
                    </select>
                    <div v-show="rule.Type == 'ExportPrinters'" class="form-control" style="padding-left: 0px; text-align: center;">Send Email To</div>
                  </div>
                  <div class="col-sm-7" v-show="rule.Action.key==='Send Email To'">
                    <input type="text" class="form-control" placeholder="Value" v-model="emailText" />
                    <va-chip v-for="(item, index) in stringToArray(rule.Action.value)" :title="item" @click="removeChip(index)"></va-chip>
                  </div>
                  <div class="col-sm-1" style="padding: 0px; padding-top: 5px;" v-show="rule.Action.key==='Send Email To'">
                    <a href="#" @click="addEmail(emailText)" title="Add Email">
                      <i class="fa fa-user-plus" style="font-size: 24px;"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="$root.isAdmin">
                <label class="col-sm-3 control-label">Dealer</label>
                <div class="col-sm-9">
                  <div class="col-sm-12">
                    <select class="form-control" v-model="rule.DealerKey" style="padding-left: 0px;">
                      <option v-for="(item,index) in $root.dealers" :data="item" :key="index" :value="item.value">
                        {{ item.title }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Customer</label>
                <div class="col-sm-9">
                  <div class="col-sm-12">
                    <select class="form-control" v-model="rule.CustomerKey" style="padding-left: 0px;">
                      <option v-for="(item,index) in customers" :data="item" :key="index" :value="item.value">
                        {{ item.title }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Active</label>
                <div class="col-sm-9">
                  <div class="col-sm-12">
                    <div class="col-sm-9" style="font-size: 30px; cursor: pointer;" @click="rule.IsActive=!rule.IsActive">
                      <i v-if="rule.IsActive" class="fa fa-toggle-on text-green"></i>
                      <i v-else class="fa fa-toggle-on text-red rotate180"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group" align="center">
                <va-alert type="danger" :dismissible="true" v-show="error" style="width: 98%;">
                  <div slot="body">
                    <i class="icon fa fa-ban"></i> {{error}}
                  </div>
                </va-alert>
              </div>
            </form>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
            <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="save" style="margin-right: 10px;"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-3"></column>
    </row>
  </div>
</template>
<script>
  import VAChip from './VAChip'
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'
  import { db } from '../firebase'

  export default {
    name: 'AddRule',
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      'va-chip': VAChip
    },
    data () {
      return {
        ruleKey: '',
        customers: [],
        title: 'Add Alert',
        // conditionKeys: ['Page Count', 'Balck Toner', 'Cyan Toner', 'Magenta Toner', 'Yellow Toner', 'Status', 'IP Address', 'MAC Address'],
        conditionKeys: [
          { title: 'Page Count', dbField: 'PageCount' },
          // { title: 'Page Usage Count', dbField: 'PageCount' },
          { title: 'Black Toner', dbField: 'BlackTonerLeft' },
          { title: 'Cyan Toner', dbField: 'CyanTonerLeft' },
          { title: 'Magenta Toner', dbField: 'MagentaTonerLeft' },
          { title: 'Yellow Toner', dbField: 'YellowTonerLeft' },
          { title: 'All Toners', dbField: 'TonerLeft' },
          { title: 'Status', dbField: 'ErrorString' },
          { title: 'IP Address', dbField: 'IPAddress' },
          { title: 'MAC Address', dbField: 'MacAddress' }
          // { title: 'Printer Site', dbField: 'PrinterSite' },
          // { title: 'Printer Customer', dbField: 'PrinterCustomer' }
        ],
        conditionOperations: ['Equal To', 'Not Equal To', 'Greater Than', 'Less Than', 'Contains', 'Changed'],
        actions: ['Send Email To', 'Log To System'],
        emailText: '',
        rule: {
          RuleKey: '',
          DealerKey: '',
          CustomerKey: '',
          Name: '',
          Description: '',
          Type: 'Information',
          Condition: {
            key: '',
            operation: '',
            value: ''
          },
          Action: {
            key: 'Send Email To',
            value: ''
          },
          IsActive: false
        },
        error: ''
      }
    },
    created () {

    },
    mounted () {
      this.$bus.$on('rulesModal-open', (args) => {
        console.log(args)
        if (args) {
          this.title = 'Edit Rule' + ' [' + args.Name + ']'
          this.ruleKey = args['.key']
          this.rule = {
            DealerKey: args.DealerKey,
            CustomerKey: args.CustomerKey,
            Name: args.Name,
            Description: args.Description,
            Type: args.Type,
            Condition: args.Condition,
            Action: args.Action,
            IsActive: args.IsActive
          }
          this.error = ''
        } else {
          this.title = 'Add Rule'
          this.reset()
          if (!this.$root.isAdmin) {
            this.rule.DealerKey = this.$root.user['.key']
          }
        }
        $('#ruleModal').modal('show')
      })
    },
    computed: {
      canExportPrinters () {
        let vm = this
        if (vm.$root.isAdmin || vm.$root.isDealer) {
          if (vm.$root.isDealer) {
            return true
          }
        }
        return false
      }
    },
    watch: {
      'rule.DealerKey' (val) {
        if (val) {
          this.loadCustomers()
        } else {
          this.customers = []
        }
      }
    },
    methods: {
      canShowRule (ruleType) {
        let vm = this
        if (ruleType.value === 'ExportPrinters') {
          if (vm.$root.isAdmin || vm.$root.isDealer) {
            return true
          }
          return false
        } else {
          return true
        }
      },
      loadCustomers () {
        console.log('loadCustomers...')
        let vm = this
        vm.customers = []
        vm.customers = vm.$root.customers.filter(function (cust) {
          return cust.dealerKey === vm.rule.DealerKey
        })

        if (vm.rule.CustomerKey && vm.rule.CustomerKey.length > 0) {
          let customer = vm.customers.find(function (cust) {
            return cust.value === vm.rule.CustomerKey
          })
          if (!customer) {
            vm.rule.CustomerKey = ''
          }
        }
      },
      removeChip (index) {
        console.log('removeChip...')
        console.log('index = ' + index)
        let arr = this.stringToArray(this.rule.Action.value)
        arr.splice(index, 1)
        this.rule.Action.value = this.arrayToString(arr, ',')
      },
      stringToArray (txt) {
        console.log('stringToArray...')
        console.log(txt)
        if (txt) {
          return txt.split(',')
        } else {
          return []
        }
      },
      arrayToString (arr, char) {
        console.log('arrayToString...')
        console.log(arr)
        console.log('char = ' + char)
        if (arr) {
          return arr.join(char)
        } else {
          return ''
        }
      },
      addEmail (emailText) {
        if (emailText) {
          if (this.rule.Action.value) {
            this.rule.Action.value = this.rule.Action.value + ',' + emailText
          } else {
            this.rule.Action.value = emailText
          }
          this.emailText = ''
        }
      },
      validateEmail (email) {
        var re = /\S+@\S+\.\S+/
        return re.test(email)
      },
      getClass () {
        for (let i = 0; i < this.$root.alertTypes.length; i++) {
          if (this.$root.alertTypes[i].value === this.rule.Type) {
            return this.$root.alertTypes[i].iconClass
          }
        }
        return ''
      },
      save () {
        let vm = this
        if (vm.isValid()) {
          let rule = {
            DealerKey: vm.rule.DealerKey,
            CustomerKey: vm.rule.CustomerKey,
            DealerCustomerKey: vm.rule.DealerKey + '_' + vm.rule.CustomerKey,
            Name: vm.rule.Name,
            Description: vm.rule.Description,
            Type: vm.rule.Type,
            Condition: vm.rule.Condition,
            Action: vm.rule.Action,
            IsActive: vm.rule.IsActive
          }
          if (this.rule.Type === 'ExportPrinters') {
            rule['ConditionText'] = 'Export Printers'
          } else {
            rule['ConditionText'] = rule.Condition.key.title + ' ' + rule.Condition.operation + ' ' + rule.Condition.value
          }
          rule['ActionText'] = rule.Action.key + ': ' + rule.Action.value
          let cust = vm.customers.find(c => c.value === vm.rule.CustomerKey)
          console.log(cust)
          if (cust) {
            rule['CustomerName'] = cust.title
          }
          if (vm.ruleKey) {
            db.ref('AlertRules/' + vm.ruleKey).set(rule)
            rule['.key'] = vm.ruleKey
            const index = vm.$parent.rules.findIndex(item => item['.key'] === vm.ruleKey)
            console.log(index)
            vm.$parent.rules[index] = rule
            vm.$parent.guidRules = vm.$root.getGUID()
            vm.$parent.loadRules()
          } else {
            db.ref('AlertRules').push(rule)
            vm.$parent.rules.push(rule)
          }
          vm.reset()
          $('#ruleModal').modal('hide')
        }
      },
      cancel () {
        this.reset()
        $('#ruleModal').modal('hide')
      },
      isValid () {
        this.error = ''

        if (this.rule.Name.length === 0) {
          this.error = '* Please enter Rule Name!'
          return false
        }

        if (this.rule.Type.length === 0) {
          this.error = '* Please select Rule Type!'
          return false
        }

        if (this.rule.Type !== 'ExportPrinters') {
          if (this.rule.Condition.key.length === 0) {
            this.error = '* Please fill Rule Condition!'
            return false
          }
          if (this.rule.Condition.operation.length === 0) {
            this.error = '* Please fill Rule Condition!'
            return false
          }
          if (this.rule.Condition.value.length === 0) {
            this.error = '* Please fill Rule Condition!'
            return false
          }

          if (this.rule.Action.key.length === 0) {
            this.error = '* Please fill Rule Action!'
            return false
          }
          if (this.rule.Action.key === 'Send Email To' && this.rule.Action.value.length === 0) {
            this.error = '* Please fill Rule Action!'
            return false
          }
        }

        if (this.rule.DealerKey.length === 0) {
          this.error = '* Please select a Dealer!'
          return false
        }
        if (this.rule.CustomerKey.length === 0) {
          this.error = '* Please select a Customer!'
          return false
        }

        return true
      },
      reset () {
        this.ruleKey = ''
        this.rule = {
          RuleKey: '',
          DealerKey: '',
          CustomerKey: '',
          Name: '',
          Description: '',
          Type: 'Information',
          Condition: {
            key: '',
            operation: '',
            value: ''
          },
          Action: {
            key: 'Send Email To',
            value: ''
          },
          IsActive: false
        }
        this.error = ''
      }
    }
  }
</script>
<style>
  .iconSuccess {
    font-size: 28px;
    color: #46c562;
  }
</style>



// WEBPACK FOOTER //
// AddRule.vue?0ef84c42